// PostHog error tracking forwards captured exceptions to GitHub issues. A
// few browser failures are user-initiated state teardown the site cannot fix
// or act on; filing them buries real crashes. Keep this list short and
// exact — anything ambiguous should keep reporting.
const NOISE_EXCEPTION_MESSAGES = [
  // Firebase's IndexedDB persistence throws this when the visitor clears
  // site data (or Safari evicts storage) mid-session.
  "Database deleted by request of the user",
  // Safari drops the IndexedDB connection when the tab is backgrounded or
  // storage is evicted; Firebase persistence reconnects on its own.
  "Connection to Indexed Database server lost",
  // IndexedDB open handed back no database (storage evicted or denied), so
  // the upgrade callback dereferences undefined. Same teardown as above.
  "createObjectStore",
  // Script injected by an in-app browser; the name (note the typo) exists
  // nowhere in our bundle or dependencies.
  "SCDynimacBridge",
  // Android WebView JS bridge failing while its host app tears the page
  // down ("Java exception was raised" / "Java object is gone").
  "Error invoking postMessage",
  // Microsoft Outlook's link-scanning agent evaluating the page; the
  // message never occurs in real browsers.
  "Object Not Found Matching Id",
  // The visitor's connection dropped mid-request to Firebase Auth. Purely
  // environmental; the UI surfaces its own retry messaging.
  "auth/network-request-failed",
  // A cross-origin script failed and the browser redacted everything but
  // this literal string. No stack, no message, nothing to act on.
  "Script error.",
  // A visitor's browser extension talking to itself via the WebExtension
  // messaging API after its tab context vanished. runtime.sendMessage exists
  // nowhere in our bundle; only injected content scripts can throw this.
  "Invalid call to runtime.sendMessage",
];

export function isNoiseException(message) {
  return (
    typeof message === "string" &&
    NOISE_EXCEPTION_MESSAGES.some((noise) => message.includes(noise))
  );
}

/** posthog-js `before_send` hook: drop $exception events whose message is
 * known non-actionable noise; pass every other event through untouched. */
export function dropNoiseExceptions(event) {
  if (!event || event.event !== "$exception") return event;
  const list = event.properties?.$exception_list;
  const messages = Array.isArray(list) ? list.map((item) => item?.value) : [];
  messages.push(event.properties?.$exception_message);
  // Any entry matching drops the whole event: a wrapper error whose cause
  // chain includes the noise failure is just as non-actionable as the root.
  return messages.some(isNoiseException) ? null : event;
}
